import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import {
  BottomButton,
  DateField,
  GuideBox,
  Layout,
  StickyContent,
  Textarea,
  Title,
  ToggleBox,
} from "../../components";
import { white } from "assets/styleUtils";
import { footerState, userSelectCounseling } from "recoil/atoms";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

type TRank = {
  [key: string]: string | null;
};

export default function CounselingDate() {
  const setIsFooter = useSetRecoilState(footerState);
  const navigate = useNavigate();
  const recoilSelectCounseling = useRecoilValue(userSelectCounseling);
  const recoilSetSelectCounseling = useSetRecoilState(userSelectCounseling);
  const [inputText, setInputText] = useState("");
  const [selectDate, setSelectDate] = useState<TRank[]>([
    { priority1: null },
    { priority2: null },
    { priority3: null },
    { priority4: "" },
  ]);
  const priorityNum = ["1순위", "2순위", "3순위"];

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setInputText(newValue);
    setSelectDate((prevState) => {
      const newState = [...prevState];
      newState[3] = { priority4: newValue };

      return newState;
    });
  };

  const handleDateChange = (date: string, index: number) => {
    const duplicateIndex = selectDate.findIndex(
      (item, i) =>
        Object.values(item).some((value) => value === date) && i !== index
    );

    if (duplicateIndex !== -1) {
      setSelectDate((prevState) => {
        const newState = [...prevState];
        newState[index] = { [`priority${index + 1}`]: null };
        return newState;
      });
      return toast.error("1~3순위 동일한 날짜 선택이 불가합니다.");
    } else {
      setSelectDate((prevState) => {
        const newState = [...prevState];
        newState[index] = { [`priority${index + 1}`]: date };
        return newState;
      });
    }
  };
  const trueSelectDate = selectDate.filter((data) =>
    Object.values(data).some((value) => value === null)
  );

  useEffect(() => {
    setIsFooter(true);

    const unsubscribe = () => {
      setIsFooter(false);
    };

    return () => {
      unsubscribe();
    };
  });

  useEffect(() => {
    if (recoilSelectCounseling && recoilSelectCounseling.length > 0) {
      setSelectDate(recoilSelectCounseling);
    }
  }, []);

  return (
    <>
      <div style={{ paddingBottom: "100px" }}>
        <Layout pdt={60} pdb={40} background={white}>
          <Title title="방문상담 일시를\n알려주세요." />

          <ToggleBox
            hiddenBorder
            buttonText="방문상담 희망 일시를 선택해주세요."
            toggleContent={
              <ul className={styles.dateInputList}>
                {priorityNum.map((num, i) => (
                  <li key={i}>
                    <p>{num} 방문 상담 희망일*</p>
                    <DateField
                      index={i}
                      onChange={(date: string) => handleDateChange(date, i)}
                      value={selectDate[i][`priority${i + 1}`] || ""}
                    />
                  </li>
                ))}
              </ul>
            }
          />

          <ToggleBox
            buttonText="방문상담 시간 관련 특이사항"
            buttonSubCont={
              <p style={{ marginTop: 10 }}>
                *인기 웨딩홀의 경우 방문 희망일이 모두 마감일 수 있으니,
                <br />
                가능 일정이 추가적으로 있으신 경우 더 자세히 적어주시면
                <br />
                예약이 수월합니다
              </p>
            }
            toggleContent={
              <Textarea
                style={{
                  height:
                    inputText.length > 0
                      ? !inputText.includes("\n")
                        ? 40
                        : inputText.split("\n").length * 20
                      : 60,
                }}
                placeholder="2,3 순위 날짜에는 4시 이후만 가능하고, 1순위 날짜는 다 가능해요. 12 이전은 시간이 안돼요"
                onChange={handleInputChange}
                value={Object(selectDate[3])[`priority${4}`]}
              />
            }
          />
        </Layout>
        <GuideBox
          title="웨딩홀 예약 신청 시 참고사항"
          list={[
            "꼭 방문이 가능하신 일정으로 1~3순위 상담 희망 일을 모두 신청해주세요. (상담 가능한 시간으로 예약)",
            "희망 상담일이 모두 마감인 경우 회원님께 채팅으로 가능 일자를 개별 안내 드립니다.",
            `예약 변경&취소 가능 회수는 웨딩홀별 총 1회로 희망 상담일은 신중하게 체크 후 예약 부탁드립니다. 2회 이상 변경&취소 시 재예약이 어려운 점 참고 부탁드립니다.`,
            "웨딩홀 예약 접수는 '최대 5회'까지만 진행 가능합니다. 웨딩홀 예약 이후 취소하셔도 '예약 접수' 기준으로 카운팅되며 횟수 초과 시 메이크마이웨딩을 통한 추가 예약은 불가한 점 양해 부탁 드립니다.",
          ]}
        />
      </div>
      <StickyContent type="bottom">
        <BottomButton
          nextButtonDisabled={
            selectDate.length > 2 && trueSelectDate.length == 0 ? false : true
          }
          prevButtonEvent={() => navigate(-1)}
          nextButtonEvent={() => {
            trueSelectDate.length === 0 &&
              (recoilSetSelectCounseling(selectDate),
              navigate("/counseling/info"));
          }}
        />
      </StickyContent>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1300}
        theme="light"
      />
    </>
  );
}
